const messages = {
    // branding
    'branding.name': 'WatchESPN',
    // meta
    'meta.keywords': 'watchespn, watch espn, watchespn mobile, watchespn xbox live, live sports, watch live sports, ' +
    'watch espn online, watch espn on xbox, watch espn on mobile phone, espn, espn2, espn3, espnu',
    'meta.title.home': 'WatchESPN: Live Sports, Game Replays, Video Highlights',
    'meta.description.home': 'Stream live sports, watch game replays, get video highlights, and access featured ESPN ' +
    'programming on your computer, mobile device, and TV with WatchESPN.',
    'meta.title.schedule': 'Schedule: Live, Upcoming, Replays - WatchESPN',
    'meta.description.schedule': 'Get live, upcoming, and replay schedule information for your favorite sports and shows ' +
    'across every ESPN network on WatchESPN.',
    'meta.title.features': 'Featured Videos - WatchESPN',
    'meta.description.features': 'Watch featured news clips, game highlights, and special ESPN programming on WatchESPN.',
    'meta.title.collection': '{name} - WatchESPN',
    'meta.description.collection': 'Watch videos from the {name} collection on WatchESPN.',
    'meta.title.player': '{name} - WatchESPN',
    'meta.description.player': 'Watch the {name} video on WatchESPN.',
    'meta.title.activate': 'Activate - WatchESPN',
    'meta.description.activate': 'Activate your device',
    // schedule
    'schedule.header': 'Schedule',
    'schedule.live': 'Live Now',
    'schedule.upcoming': 'Upcoming',
    'schedule.replay': 'Replay',
    'schedule.allSports': 'All Sports',
    'schedule.allNetworks': 'All Networks',
    'schedule.replay.all': 'All',
    'schedule.replay.today': 'Today',
    'schedule.replay.last7Days': 'Last 7 days',
    'schedule.replay.last14Days': 'Last 14 days',
    'schedule.replay.last30Days': 'Last 30 days',
    // schedule module
    'schedule.module.header.live': 'Top Live',
    'schedule.module.header.upcoming': 'Upcoming',
    // search
    'search.placeholder': 'Find your team, event, or show...',
    'search.results.message': 'Search results for {query}',
    // player
    'player.error.defaultMessage': 'This network is not included in your current television subscription. Please contact your provider to upgrade.',
    'player.error.unexpectedMessage': 'An unexpected error occurred during authorization. Please refresh the page to try again.',
    // provider dialog
    'search.filter.placeholder': 'Search...',
    'provider.dialog.title': 'Choose Provider',
    'provider.dialog.subtitle': 'All Providers (A-Z):',
    'provider.dialog.subtitle.tier1': 'Choose Provider:',
    'provider.dialog.description': 'ESPN\'s live TV networks are available for {noCost} ' +
    'to consumers of the providers listed below. Need help? Check {link} or call {call}.',
    'provider.dialog.description.noCost': 'no additional cost',
    'provider.dialog.faq.link': 'http://www.espn.com/watchespn/faq',
    'provider.dialog.faq.label': 'FAQs',
    'provider.dialog.call': '888-549-ESPN',
    // sign out
    'signout.message': 'Do you want to sign out of your {providerName} account?',
    'signout.label': 'Sign Out',
    // misc
    'live': 'AO VIVO'
};

export default messages;



// WEBPACK FOOTER //
// ./app/lib/i18n/pt.js